import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Loader,
  Container,
  Modal,
  Table,
  Footer,
  Pagination,
} from "rsuite";
import "./Customers.css";
import { useTranslation } from "react-i18next";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import CustomCell from "../../components/Elements/CustomCell";
import { ToastContainer } from "react-toastify";
import { displayField } from "../../../utils/helpers";

const ViewFailedCustomers = ({
  failedData,
  openModal,
  setOpenModal,
  ...props
}: {
  failedData?: any;
  openModal: boolean;
  setOpenModal: Function;
}) => {
  const { t } = useTranslation();
  const { Cell, Column } = Table;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (failedData) {
      setData((prevData) => [...prevData, ...failedData]);
    }
  }, [failedData]);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("FAILED")} {t("CUSTOMERS")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="customers view-customers">
            <Container className="container">
              <div className="">
                <Table
                  height={400}
                  fillHeight={true}
                  data={data}
                  loading={loading}
                  bordered={true}
                  cellBordered
                  hover={true}
                >
                  <Column width={130}>
                    <CustomHeaderCell>{t("MOBILE")}</CustomHeaderCell>
                    <CustomCell dataKey="mobile" />
                  </Column>

                  <Column width={150}>
                    <CustomHeaderCell>
                      {t("FIRST")} {t("NAME")}
                    </CustomHeaderCell>
                    <CustomCell dataKey="fname" />
                  </Column>

                  <Column width={150}>
                    <CustomHeaderCell>
                      {t("LAST")} {t("NAME")}
                    </CustomHeaderCell>
                    <CustomCell dataKey="lname" />
                  </Column>
                  <Column width={80}>
                    <CustomHeaderCell>{t("GENDER")}</CustomHeaderCell>
                    <CustomCell dataKey="gender" />
                  </Column>
                  <Column flexGrow={1}>
                    <CustomHeaderCell>{t("ERROR")}</CustomHeaderCell>
                    <CustomCell dataKey="store_name">
                      {(rowData: any) => (
                        <span title={displayField(rowData.error)}>
                          {displayField(rowData.error)}
                        </span>
                      )}
                    </CustomCell>
                  </Column>
                </Table>
              </div>
              <Footer className="footer">
                <Pagination
                  ellipsis
                  boundaryLinks
                  maxButtons={5}
                  size="xs"
                  layout={["total"]}
                  total={data.length}
                  limit={data.length}
                />
              </Footer>
              <ToastContainer />
              <ButtonToolbar className="btn-center">
                <Button
                  onClick={(e: any) => setOpenModal("")}
                  color="red"
                  appearance="primary"
                >
                  {t("CLOSE")}
                </Button>
              </ButtonToolbar>
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewFailedCustomers;
